import Rate from 'rc-rate';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import 'rc-rate/assets/index.css';
import Favorite from './Favorite';
import { useDispatch, useSelector } from 'react-redux';
import {
  onUpdateFavoriteVideoAfterRate,
  updateModuleSectionVideoRate,
} from '../redux/actions/sectionActions';
import CustomSpinner from './CustomSpinner';
import { replaceFavoriteVideos } from '../redux/actions/favoriteActions';
import { Badge } from 'react-bootstrap';
import { getSectionByVideoFromMenu } from '../redux/actions/videoActions';
import { CLOUDFRONT_SECURE_PROXY } from '../constants/constants';
import RateControl from './RateControl';

const CustomVideo = ({
  video,
  url,
  onProgress,
  onEnded,
  playing,
  onPlay,
  canRate = true,
  canFav = true,
  onScreener
}) => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const dispatch = useDispatch();
  const { isHelpCenter } = useSelector((state) => state.course);
  const { openFavoriteSection } = useSelector((state) => state.favorite);
  const { updateFavoriteVideoAfterRate } = useSelector(
    (state) => state.section
  );

  const [rate, setRate] = useState(0);
  const [startPosition, setStartPosition] = useState(0);
  const [videoSubtitles, setVideoSubtitles] = useState(null);
  const [haveSubtitlesBeenParsed, setHaveSubtitlesBeenParsed] = useState(false);

  useEffect(() => {
    if (video && video.user_rating) {
      setRate(
        video?.user_rating && video?.user_rating.length
          ? video?.user_rating[0].rating
          : 0
      );
    }

    if (
      video &&
      video.progresses &&
      video.progresses.length &&
      video.progresses[0].progress < +video.duration
    ) {
      setStartPosition(video.progresses[0].progress);
    }

    // Define the AWS subtitle URL
    const subtitleUrl =
      CLOUDFRONT_SECURE_PROXY +
      '0000_AmazonTranscribeSubtitles/video' +
      video.id +
      '.vtt';

    console.log('Attempting to fetch subtitles from: ', subtitleUrl);

    // Always try AWS first
    fetch(subtitleUrl)
      .then((res) => {
        if (!res.ok) {
          // Silently fall back without throwing or logging an error
          return null; // Return null to signal no subtitles
        }
        return res.blob();
      })
      .then((blob) => {
        if (blob) {
          // Only set subtitles if we got a valid blob from AWS
          let objectURL = URL.createObjectURL(blob, { type: 'text/vtt' });
          setVideoSubtitles(objectURL);
        } else {
          // If blob is null (e.g., 404), set video subtitles null
          setVideoSubtitles(null);
        }
        setHaveSubtitlesBeenParsed(true);
      })
      .catch((err) => {
        console.log('Subtitles not found on AWS, set video subtitles null:');
        setVideoSubtitles(null);
        setHaveSubtitlesBeenParsed(true);
      })
      .finally(() => {
        // Accessibility tweaks for preview
        const preview = document.getElementsByClassName('react-player__preview');
        if (preview[0]) {
          preview[0].ariaLabel = 'Play video';
          preview[0].role = 'button';
          preview[0].ariaPressed = false;
        }
      });
  }, [video]);

  function onVideoTitleLinkClick() {
    const videoPreview = document
      .getElementById('reactplayercontrol' + video.id)
      .querySelector('.react-player__preview');
    if (videoPreview) videoPreview.click();
  }

  function translateCloudfrontUrl(rawS3Url) {
    const urlObj = new URL(rawS3Url);
    return CLOUDFRONT_SECURE_PROXY.replace(/\/$/, '') + urlObj.pathname;
  }

  useEffect(() => {
    if (updateFavoriteVideoAfterRate) {
      dispatch(replaceFavoriteVideos(updateFavoriteVideoAfterRate));
      dispatch(onUpdateFavoriteVideoAfterRate(undefined));
    }

    // eslint-disable-next-line
  }, [updateFavoriteVideoAfterRate]);

  const onChangeRating = (videoRate, videoId) => {
    // avoid scrolling effect
    dispatch(getSectionByVideoFromMenu(0));

    setRate(videoRate);
    dispatch(updateModuleSectionVideoRate(videoId, videoRate));
  };

  if (!video) {
    return <CustomSpinner />;
  }

  return (
    <>
      <div>
        <h3 className="text-color-gray font-24 font-poppins fw-300">
          <a
            href="#"
            onClick={onVideoTitleLinkClick}
            id={'videoheader' + (video ? video.id : '0')}
            className="text-color-gray font-24 font-poppins fw-300"
            style={{ textDecoration: 'none' }}
            aria-label={video ? video.title + ' video player' : 'Video Title'}
            aria-expanded={true}
            role="button"
          >
            {video?.title || 'Video Title'}
          </a>
        </h3>
      </div>

      {!video.screener_type === null || video.screener_type === undefined ?
        (<div className="player-wrapper">
          {haveSubtitlesBeenParsed && (
            <ReactPlayer
              id={'reactplayercontrol' + video.id}
              onProgress={onProgress}
              onEnded={onEnded}
              url={video?.stream_url}
              width="100%"
              height="auto"
              light={
                video?.thumbnail_url
                  ? translateCloudfrontUrl(video?.thumbnail_url)
                  : ''
              }
              playsInline={true}
              playing={playing}
              onError={(err) => {
                console.log(err);
              }}
              config={
                video?.stream_url && videoSubtitles != null
                  ? {
                    forceHLS: !isSafari,
                    file: {
                      forceHLS: !isSafari,
                      attributes: {
                        preload: isSafari ? 'auto' : 'metadata',
                        autoPlay: false,
                        crossOrigin: 'anonymous',
                      },
                      tracks: [
                        {
                          kind: 'subtitles',
                          src: videoSubtitles,
                          srcLang: 'en',
                          default: localStorage.getItem('subtitlesToggle') == 1,
                        },
                      ],
                    },
                    hlsOptions: {
                      minAutoBitrate: 7000,
                      startLevel: 4,
                      startPosition: startPosition,
                    },
                  }
                  : {}
              }
              onClickPreview={() => {
                if (isSafari) {
                  // Safari workaround
                  setTimeout(() => {
                    try {
                      document
                        .getElementById(`video-${video?.id}`)
                        .querySelector('video')
                        .play();
                    } catch (e) {
                      console.log('Safari playback failed:', e);
                      onPlay(video?.id); // Fallback
                    }
                  }, 300);
                } else {
                  onPlay(video?.id);
                }
              }}
              onPlay={() => {
                onPlay(video?.id);
              }}
              controls
            />
          )}
        </div>
        ) : ''}

      {video.screener_type ?
        (<div className="player-wrapper">
          <div className="mt-3">
            <img
              src={video.knowledge_check_banner_url}
              onClick={(e) => {
                onScreener(video);
              }}
              width="100%"
              height="auto"
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
        ) : ''}

      <div className="video-description-container">
        <div className="d-flex flex-wrap justify-content-between align-items-start align-items-sm-center">
          <div className="ml-2">
            {canFav && !isHelpCenter ? (
              <Favorite
                video={video}
                user_favorite={video?.user_favorite} />
            ) : (
              // OR
              ''
            )}
          </div>
          {canRate && !isHelpCenter ? (
            <div aria-hidden={true} className="like-section mr-2">
            </div>
          ) : (
            // OR
            ''
          )}
        </div>

        {false ? (
          video.tags && video.tags !== '' ? (
            <div className="tags d-flex align-items-start justify-content-end mt-3">
              {video.tags.split(',').map((tag, i) => {
                return (
                  <div key={i}>
                    <Badge
                      className="bg-color-accent text-white font-weight-bolder mr-2"
                      bg="primary"
                    >
                      {tag}
                    </Badge>
                  </div>
                );
              })}
            </div>
          ) : (
            // OR
            ''
          )
        ) : (
          // OR
          ''
        )}
        <div className="video-description">
          <div className="description">{video?.description || 'No Title'}</div>
        </div>
      </div>
    </>
  );
};

export default React.memo(CustomVideo);
